const importers = {
        './src/stories/icons.stories.mdx': async () => import('/@fs//opt/build/repo/src/stories/icons.stories.mdx'),
  './src/stories/colors.stories.mdx': async () => import('/@fs//opt/build/repo/src/stories/colors.stories.mdx'),
  './src/components/title/title.stories.tsx': async () => import('/@fs//opt/build/repo/src/components/title/title.stories.tsx'),
  './src/components/text/text.stories.tsx': async () => import('/@fs//opt/build/repo/src/components/text/text.stories.tsx')
    };

    export async function importFn(path) {
        return importers[path]();
    }